// angular
// .module("HeroPRO")
// .controller("LicensesTableController",licensesTableController);

import _ from 'lodash';

/* @ngInject */
export default function licensesTableController($state, LicensesFactory, LicenseTypes, $scope, UserData, ModalService, moment) {
    const vm = this;
    vm.licenseList = [];
    vm.licenseLength = 0;
    vm.licensesHeader = '';
    vm.loadingLicenses = true;
    vm.ContractorId = -1;
    vm.OrganizationId = -1;
    init();
    vm.expireText = function (row) {
        const today = new Date();
        if (row.LicenseExpireDate && row.LicenseExpireDate < today.getDate()) {
            return 'Expired';
        } else if (row.LicenseExpireDate && row.LicenseExpireDate > today.getDate()) {
            return 'Expires';
        }
        return '';
    };

    vm.CanBeEdited = function (license) {
        let editable = true;

        switch (license.OrganizationLicenseTypeId) {
        case LicenseTypes.CSLB:
        case LicenseTypes.CILB:
            editable = false;
            break;
        default:
            break;
        }

        return editable;
    };

    vm.deleteLicense = function (license) {
        const licenseInfo = {
            ContractorLocationId: vm.ContractorId,
            OrganizationId: vm.OrganizationId,
            OrganizationLicenseId: license.OrganizationLicenseId,
            State: license.State,
        };
        const modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/licenses/deleteLicense/deleteLicense.html',
            windowClass: 'delete-license',
            controller: 'DeleteLicenseController',
            controllerAs: 'deleteLicense',
            size: 'full-screen',
            resolve: {
                selectedLicense() {
                    return licenseInfo;
                },
            },
        });
        modal.result.then((result) => {
            if (result === true) {
			 getLicenses(vm.OrganizationId);
            }
            ModalService.closeLgModal();
        });
    };

    vm.addLicense = function () {
        const modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/licenses/addLicense/addLicense.html',
            windowClass: 'add-license',
            controller: 'AddLicenseController',
            controllerAs: 'addLicense',
            size: 'full-screen',
            resolve: {
			    activeStates() {
			        return filterStates(vm.licenseList);
			    },
			    contractorId() {
			        return vm.ContractorId;
			    },
			    organizationId() {
			        return vm.OrganizationId;
			    },
			    edit() {
			        return false;
			    },
			    licenseInfo() {
			        return null;
			    },
			    licenseList() {
			        return vm.licenseList;
			    },
            },
        });
        modal.result.then((result) => {
            if (result === true) {
			 getLicenses(vm.OrganizationId);
            }
            ModalService.closeLgModal();
        });
    };

    vm.editLicense = function (license) {
        const modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/licenses/addLicense/addLicense.html',
            windowClass: 'add-license',
            controller: 'AddLicenseController',
            controllerAs: 'addLicense',
            size: 'full-screen',
            resolve: {
                activeStates() {
                    return LicensesFactory.getActiveStates();
                },
                contractorId() {
                    return vm.ContractorId;
                },
                organizationId() {
                    return vm.OrganizationId;
                },
                edit() {
                    return true;
                },
                licenseInfo() {
                    return license;
                },
                licenseList() {
                    return vm.licenseList;
                },
            },
        });
        modal.result.then((result) => {
            if (result === true) {
                getLicenses(vm.OrganizationId);
            }
            ModalService.closeLgModal();
        });
    };

    /* Private functions */

    function buildLicenseTableHeader() {
        if (vm.licenseLength < 2) {
            vm.licensesHeader = 'License';
        } else {
            vm.licensesHeader = 'Licenses';
        }
    }

    function init() {
        vm.loadingLicenses = true;
        UserData.getCurrentKBYGLocation().then((data) => { // changed to getCurrentKBYGLocation from getCurrentLocation in case of no location selected.
            vm.OrganizationId = data.OrganizationId;
            vm.ContractorId = data.ContractorId;
            getLicenses(vm.OrganizationId);
        });
    }


    function getLicenses(organizationId) {
        LicensesFactory.getLicenses(organizationId).then((response) => {
            vm.licenseList = response.data.Data.Licenses;
            _.each(vm.licenseList, (license, key) => {
                license.Expire = moment.isDate(license.LicenseExpireDate) && moment(license.LicenseExpireDate).isBefore() ? 'Expired' : 'Expires';
                license.LicenseType = license.OrganizationLicenseTypeId === 1 ? 'CSLB' : license.LicenseType;
                license.CanBeDeleted = determineDelete(license, key); // license.Licenses > 1 ? true : false;
            });
            vm.licenseLength = vm.licenseList ? vm.licenseList.length : 0;
            buildLicenseTableHeader();
            vm.loadingLicenses = false;
        });
    }

    function filterStates(licenses) {
        return LicensesFactory.getActiveStates().then((data) => {
            const states = data.data || data;

            if (licenses.length > 0) {
                _.each(licenses, (exist) => {
                    // if there is an Expiration date and the license is NOT expired, remove the corresponding state
                    if (exist.LicenseExpireDate && new Date(exist.LicenseExpireDate) > new Date()) {
                        const index = _.findIndex(states, state => state.LicenseTypes[0].LicenseTypeId === exist.OrganizationLicenseTypeId);

                        if (index > -1) {
                            states.splice(index, 1);
                        }
                    }
                });
            }

            return states;
        });
    }

    function determineDelete(license) {
        if (license.Licenses === 1) {
            return false;
        }

        if (license.IntegrationType !== 3 && license.IntegrationType !== 2) {
            return true;
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/accounts/licenses/licensesTable/licensesTableController.js